module.exports = __webpack_public_path__ + "static/cube24-e6a1fb0ddfc086f580d50b5906d85a4b.svg";